/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDocumentResponse } from '../../models/get-document-response';

export interface GetRegulation$Params {
}

export function getRegulation(http: HttpClient, rootUrl: string, params?: GetRegulation$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDocumentResponse>> {
  const rb = new RequestBuilder(rootUrl, getRegulation.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDocumentResponse>;
    })
  );
}

getRegulation.PATH = '/api/documents/regulation';
